import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, IconButton } from "@mui/material";
import Add from "@mui/icons-material/Add";
import ModeEditOutlineTwoTone from "@mui/icons-material/ModeEditOutlineTwoTone";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AppTable from "components/Shared/AppTable";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import TableFilter from "components/Shared/AppTable/TableFilter";

import { useLazyGetTeamListQuery } from "store/services/teamApi";

import { useAppMeta } from "hooks";

const TeamListScreen = () => {
  const breadcrumbs = [{ title: "Teams" }];

  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("search") || "";

  const columns = [
    { name: "Name", selector: (row) => row?.name ?? "N/A" },
    { name: "Manager", selector: (row) => row?.manager?.name ?? "N/A" },
    {
      name: "Members",
      cell: (row) => (
        <div className="flex">
          {row?.members?.slice(0, 2)?.map((member, index) => (
            <div key={member?._id}>
              {member?.name}
              {index < 1 && <span className="mr-1">,</span>}
              {row?.members?.length > 2 &&
                `& ${row?.members?.length - 2} others`}
            </div>
          ))}
        </div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/team/${row._id}/detail`}>
            <IconButton color="primary" aria-label="Edit Task">
              <InfoOutlined />
            </IconButton>
          </Link>

          <Link to={`/app/crm/team/${row._id}/edit`}>
            <IconButton size="small" aria-label="Edit Task">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  // RTK Query
  const [fetchTeams, { data: teamList, isLoading: loadingTeams, error }] =
    useLazyGetTeamListQuery();

  React.useEffect(() => {
    fetchTeams();
  }, [fetchTeams]);

  useAppMeta("Teams");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TableFilter searchLabel="Name">
          <div className="font-medium">Teams</div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={
            teamList?.filter(
              (item) =>
                item && item.name.toLowerCase().includes(keyword.toLowerCase())
            ) ?? []
          }
          progressPending={loadingTeams}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TeamListScreen;

const PageActions = () => {
  return (
    <Link to="/app/crm/team/create">
      <Button startIcon={<Add />} variant="contained">
        New Team
      </Button>
    </Link>
  );
};
